import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_participate_in_any_of_the_following_activities_rela'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_participate_in_any_of_the_following_activities_rela',
  name: 'Did the facility participate in any of the following activities related to community service? (SELECT all that apply with an "X":)',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'THE_FACILITY_SPONSORED__PAID_FOR_AND_OR_ORGANIZED__A_COMMUNITY_',
      text: 'The facility sponsored (paid for and/or organized) a community service event',
      externalIds: [
        {
          id: 'ab-7-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-7-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKERS_WERE_ENCOURAGED_TO_VOLUNTARILY_ENGAGE_IN_COMMUNITY_SERV',
      text: 'Workers were encouraged to voluntarily engage in community service',
      externalIds: [
        {
          id: 'ab-7-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-7-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKERS_WERE_PERMITTED_CERTAIN_HOURS_TO_VOLUNTARILY_ENGAGE_IN_C',
      text: 'Workers were permitted certain hours to voluntarily engage in community service during working hours and were not penalized for the hours served',
      externalIds: [
        {
          id: 'ab-7-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-7-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'BLOOD_DONATION_PROGRAMS',
      text: 'Blood Donation Programs',
      externalIds: [
        {
          id: 'ab-7-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-7-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GENDER_EQUALITY_AND_EMPOWERMENT_PROGRAMS',
      text: 'Gender equality and empowerment programs',
      externalIds: [
        {
          id: 'ab-com-13x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-com-14f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-7-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-7-5f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-7-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'THE_FACILITY_SPONSORED__PAID_FOR_AND_OR_ORGANIZED__A_COMMUNITY_',
                'WORKERS_WERE_ENCOURAGED_TO_VOLUNTARILY_ENGAGE_IN_COMMUNITY_SERV',
                'WORKERS_WERE_PERMITTED_CERTAIN_HOURS_TO_VOLUNTARILY_ENGAGE_IN_C',
                'BLOOD_DONATION_PROGRAMS',
                'GENDER_EQUALITY_AND_EMPOWERMENT_PROGRAMS',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 24740,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
